import React from 'react';
import { Link } from 'react-router-dom';
import { Bike } from 'lucide-react';

const Logo = ({ variant = 'default', className = '' }) => {
  const textColor = variant === 'light' ? 'text-white' : 'text-dark-900';
  const subTextColor = variant === 'light' ? 'text-dark-300' : 'text-dark-400';

  return (
    <Link to="/" className={`flex items-center gap-3 group ${className}`}>
      <div className="w-11 h-11 rounded-xl bg-athletic-600 flex items-center justify-center transform group-hover:-translate-y-0.5 transition-transform shadow-soft">
        <Bike className="w-6 h-6 text-white" strokeWidth={2} />
      </div>
      <div className="flex flex-col leading-none">
        <span className={`font-display font-bold text-[22px] tracking-tight ${textColor} transition-colors`}>
          Cycle Market <span className="text-athletic-600">Direct</span>
        </span>
        <span className={`text-[10px] font-medium uppercase tracking-[0.24em] mt-1 ${subTextColor} transition-colors`}>
          Bike Parts &amp; Supplies
        </span>
      </div>
    </Link>
  );
};

export default Logo;
